import { render, staticRenderFns } from "./ot-create-document-associations-dialog.vue?vue&type=template&id=05482529&scoped=true&"
import script from "./ot-create-document-associations-dialog.vue?vue&type=script&lang=ts&"
export * from "./ot-create-document-associations-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./ot-create-document-associations-dialog.vue?vue&type=style&index=0&id=05482529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05482529",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
